import { SponsorDetails } from '@/modals/sponsor/SponsorDetails';
import { Component, OnInit } from '@angular/core';
import { AppService } from '@services/app.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-donate',
  templateUrl: './donate.component.html',
  styleUrls: ['./donate.component.scss']
})
export class DonateComponent implements OnInit {

 donates: SponsorDetails[] = [];
  filteredDonates: SponsorDetails[] = [];
  adminSponsorModal: boolean = false;
  sponsorD!: number;
  newPaymentStatus: string = '';
  paymentSt: string = '';
   selectedSponsor: SponsorDetails | null = null;

  // Filters
  searchTerm: string = '';
  selectedStatus: string = '';
  selectedDate: string = '';

  totalPaidAmount: number = 0;

  constructor(private appService: AppService,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService
  ) { }

  ngOnInit(): void {
    this.loadSponsors();
  }

  loadSponsors(): void {

    this.spinner.show()

    this.appService.getAllSponsors().subscribe({
      next: (data) => {
        this.donates = data.filter((s: SponsorDetails) => s.referenceType?.toLowerCase() === 'donater')
        .sort((a, b) => b.sponsorDetailsId - a.sponsorDetailsId);
        this.applyFilters();
      },
      error: (err) => {
        console.error('Error loading donaters:', err);
      },
      complete: () => {
        setTimeout(() => this.spinner.hide(), 2000)
      }
    });
  }

  applyFilters(): void {
    this.filteredDonates = this.donates.filter((sponsor) => {
      const matchesSearch = `${sponsor.firstName} ${sponsor.lastName}`.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        sponsor.emailAddress?.toLowerCase().includes(this.searchTerm.toLowerCase()) || sponsor.phoneNumber?.includes(this.searchTerm);
      const matchesStatus = !this.selectedStatus || sponsor.paymentStatus === this.selectedStatus;
      const matchesDate = !this.selectedDate ||
        (sponsor.transactionDetails && sponsor.transactionDetails.some(td => {
          const date = new Date(td.createdAt || 0).toISOString().split('T')[0];
          return date === this.selectedDate;
        }));
      return matchesSearch && matchesStatus && matchesDate;
    });

    // Recalculate total paid amount
    this.totalPaidAmount = this.filteredDonates.reduce((sum, sponsor) => {
      const amount = parseFloat(sponsor.amount || '0');
      return sum + (isNaN(amount) ? 0 : amount);
    }, 0);
  }

  getTransactionId(sponsor: SponsorDetails): string {
    if (!sponsor.transactionDetails || sponsor.transactionDetails.length === 0) {
      return 'No Transaction';
    }
    return sponsor.transactionDetails[0].transactionId || 'No Transaction';
  }

  getTransactionDate(sponsor: SponsorDetails): string {
    if (!sponsor.transactionDetails || sponsor.transactionDetails.length === 0) {
      return 'N/A';
    }
    return this.getPaymentDate(sponsor.transactionDetails[0].createdAt);
  }

  getPaymentDate(createdAt?: number): string {
    if (!createdAt) return 'N/A';
    const date = new Date(createdAt);
    return date.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  }

  openingSponsor(): void {
    this.adminSponsorModal = !this.adminSponsorModal;
  }
  confirmPaymentUpdate() {
    if (!this.sponsorD || !this.newPaymentStatus) {  // use newPaymentStatus here
      console.error('Missing sponsor ID or payment status.');
      return;
    }

    const body = {
      sponsorDetailsId: this.sponsorD,
      paymentStatus: this.newPaymentStatus
    };

    this.spinner.show();

    this.appService.updateSponsorPaymentStatus(body).subscribe({
      next: () => {
        if (this.selectedSponsor) {
          this.selectedSponsor.paymentStatus = this.newPaymentStatus;
        }
        this.adminSponsorModal = false;
        this.loadSponsors();
        this.toaster.success('Payment status updated successfully.');
      },
      error: (err) => {
        console.error('Failed to update sponsor payment:', err);
      },
      complete: () => {
        setTimeout(() => this.spinner.hide(), 2000);
      }
    });
  }

  paymentUpdate(paymentStatus: string, sponsorDetailsId: number): void {
    this.adminSponsorModal = true;

    this.paymentSt = paymentStatus;
    this.sponsorD = sponsorDetailsId;
    this.newPaymentStatus = paymentStatus;

    this.selectedSponsor = this.donates.find(s => s.sponsorDetailsId === sponsorDetailsId) || null;
  }
}
